import Grid from "@mui/material/Grid";
import Avatar from "@mui/material/Avatar";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import MoreVertIcon from "@mui/icons-material/MoreVert";

const EmailContentHeader = ({ handleToggleView, user }: any) => {
  const { profileUrl, firstName, lastName, email, emailTo, date } = user || {};

  return (
    <Grid
      container
      justifyContent="space-between"
      alignItems="center"
      sx={{
        color: "#3D4043",
        paddingBottom: "8px",
        borderBottom: "1px solid #E9E9E9",
      }}
    >
      <Box display="flex" alignItems="center" gap="8px">
        <Box>
          {profileUrl && (
            <Avatar src={profileUrl} sx={{ width: "40px", height: "40px" }} />
          )}
          {!profileUrl && (
            <Avatar
              sx={{
                fontSize: "15px",
                color: "#3D4043",
                letterSpacing: "-2px",
                width: "40px",
                height: "40px",
              }}
            >
              {firstName?.[0]} {lastName?.[0]}
            </Avatar>
          )}
        </Box>
        <Box>
          <Typography
            sx={{
              color: "#3D4043",
              fontSize: "12px",
            }}
          >
            {`${firstName} ${lastName}`}
          </Typography>
          <Typography
            sx={{
              fontSize: "10px",
              color: "#c3b8b8",
            }}
          >
            to cheyenne_01@gmail.com
          </Typography>
        </Box>
      </Box>
      <Box display="flex" alignItems="center" gap="18px">
        <Typography
          sx={{
            fontSize: "12px",
            color: "#c3b8b8",
          }}
        >
          6:41 PM (3 hours ago)
        </Typography>
        <MoreVertIcon
          onClick={handleToggleView}
          sx={{
            color: "#c3b8b8",
            cursor: "pointer",
          }}
        />
      </Box>
    </Grid>
  );
};
export default EmailContentHeader;
